/*
 * Created on Thu Jul 10 2025
 *
 *  Copyright (c) Kayool Technologies PVT LTD, Inc - All Rights Reserved 2025 Jagan
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, 2025.
 */

import { Injectable, isDevMode } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

declare var gtag: Function; // Use the global gtag defined in index.html

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (isDevMode()) return; // Skip tracking in development

        const navEnd = event as NavigationEnd; // Type assertion
        gtag('event', 'page_view', {
          page_path: navEnd.urlAfterRedirects,
        });
      });
  }

  trackEvent(name: string, params: any = {}) {
    if (isDevMode()) return; // Skip tracking in development

    if (typeof gtag === 'function') {
      gtag('event', name, params);
    } else {
      console.warn('gtag not loaded');
    }
  }
}
